import { useEffect } from 'react';

export interface LoadScriptProps {
  src: string;
  onLoad?: (event: Event) => void;
  onError?: (event: Event) => void;
}

export const LoadScript = (props: LoadScriptProps) => {
  const { src, onLoad, onError } = props;

  useEffect(() => {
    console.log('Im LoadScript');
    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    if (onLoad) {
      script.onload = (event) => {
        onLoad(event);
      };
    }
    if (onError) {
      script.onabort = (event) => {
        onError(event);
      };
    }

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <></>;
};
